<template>
  <el-dialog class="dialog" customClass="dialog_settings" :show-close="false" :visible="dialogs.tableSettings" :append-to-body="true" @open="handleOpen" :close-on-click-modal="false" @close="closeDialog()">
    <div slot="title" class="dialog__head">
      <div class="dialog__head-inner">
        <div class="dialog__head-item">
          <h3 class="dialog__title">Настройка списка</h3>
        </div>

        <div class="dialog__head-item">
          <button type="button" class="c-primary dialog__head-btn" @click="selectAll">Выбрать все</button>
          <button type="button" class="c-danger ml-16 dialog__head-btn" @click="unselectAll">Очистить все</button>
        </div>
      </div>
    </div>

    <div class="dialog__content">
      <ul class="settings-list">
        <li class="settings-list__item" v-for="item in tableSettings" :key="item.name">
          <el-checkbox v-model="item.visible" :disabled="item.required" :label="item.title" @change="(value) => handleSelectionChange(value, item)" />
        </li>
      </ul>
    </div>

    <footer class="dialog__footer dialog__footer_has-border mt-16">
      <div class="dialog__footer-inner">
        <div class="dialog__footer-item">
          <button type="button" class="btn btn_small" @click="setDefault">По&nbsp;умолчанию</button>
        </div>

        <div class="dialog__footer-item">
          <button type="button" class="btn btn_small btn_success" @click="saveSettings">
            Применить <icon-base width="12" height="12" viewBox="0 0 12 12" iconColor="#fff" class="btn__icon"><icon-action /></icon-base>
          </button>
          <button type="button" class="btn btn_small btn_danger" @click="closeDialog">
            Отменить <icon-base width="14" height="14" viewBox="0 0 14 14" iconColor="#fff" class="btn__icon"><icon-cancel /></icon-base>
          </button>
        </div>
      </div>
    </footer>
  </el-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { cloneDeep } from 'lodash/fp';
import MaskedInput from 'vue-masked-input';

import constants from '@/constants.js';

import dialog from '@/mixins/dialog';

export default {
  props: {
    settings: {
      required: true,
      type: Array
    }
  },
  mixins: [ dialog ],
  components: {
    MaskedInput
  },
  data() {
    return {
      tableSettings: {}
    }
  },
  methods: {
    closeDialog() {
      this.elDialogs.tableSettings = false;
    },
    handleOpen() {
      this.tableSettings = cloneDeep(this.settings);
    },
    handleSelectionChange(value, selected) {
      const item = this.tableSettings.find((item) => item.name === selected.name);

      this.tableSettings = this.tableSettings.map((item) => {
        if (item.name === selected.name) {
          item.visible = value;
        }

        return item;
      });
    },
    saveSettings() {
      this.$emit('saveTableSettings', this.tableSettings)

      this.closeDialog();
    },
    selectAll() {
      this.tableSettings = this.tableSettings.map((item) => {
        item.visible = true;

        return item;
      });
    },
    setDefault() {
      this.tableSettings = this.tableSettings.map((item) => {
        item.visible = item.default;

        return item;
      });
    },
    unselectAll() {
      this.tableSettings = this.tableSettings.map((item) => {
        if (!item.required) {
          item.visible = false;
        }

        return item;
      });
    }
  }
}
</script>
